import { useAPI } from "@travel/shared/data-access";
import { getLocationSuggestions } from "../locations-api/locations-api";
export function useLocationSearch(query) {
    return useAPI(query && query.length > 2 ? { query: query } : null, getLocationSuggestions, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });
}
